import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
// import PaymentPartiallyPaidTable from './components/PaymentPartiallyPaidTable';

const PaymentPartiallyPaid = () => {
  // const [searchString, setSearchString] = useState('');

  // const handleChange = (value) => {
  //   setSearchString(value);
  // };
  return (
    <ErrorBoundary>
      {/* <DebounceTextInput
        onInputChange={handleChange}
        delay={500} // Set your desired delay in milliseconds
        value={searchString}
      /> */}
      {/* <PaymentPartiallyPaidTable /> */}
    </ErrorBoundary>
  );
};

export default PaymentPartiallyPaid;
